import { Check, Loader2, Lock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { TIER_NAMES, tierFacts, duration } from "@/components/PlanInfo";

function describe(cfg, key, sub) {
  const [tier, kind] = key.split("_");
  const price = cfg.prices[key];
  if (kind === "day") {
    const min = cfg.pass_minutes[tier];
    return {
      title: cfg.pass_names[tier], price: `$${price}, paid once`,
      facts: tierFacts(cfg, tier, `Unlimited messages for ${duration(min)}`),
      terms: [`The pass starts with your first message (or the first feature only the pass includes) and runs for ${duration(min)}, even if you leave the app.`,
        "It doesn't renew and never lowers what your subscription already gives you."],
    };
  }
  const annual = kind === "annual";
  const terms = sub
    ? [`You're switching from ${TIER_NAMES[sub.tier]} (${sub.interval}). Stripe shows the exact amount, including any credit for unused time, before you confirm.`]
    : [`Renews automatically every ${annual ? "year" : "month"} until you cancel. Cancel any time in Billing and keep access until the end of the paid period.`];
  return { title: `${TIER_NAMES[tier]}, ${annual ? "annual" : "monthly"}`, price: `$${price} ${annual ? "a year" : "a month"}`, facts: tierFacts(cfg, tier), terms };
}

export function CheckoutSummary({ cfg, pick, sub, busy, onConfirm, onClose }) {
  if (!pick || !cfg) return null;
  const d = describe(cfg, pick, sub);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#121725] border-white/10 max-w-md sm:rounded-2xl max-h-[90dvh] overflow-y-auto" data-testid="checkout-summary">
        <DialogHeader>
          <DialogTitle className="font-display text-xl" data-testid="checkout-summary-title">{d.title}</DialogTitle>
          <DialogDescription className="text-neutral-300 text-base" data-testid="checkout-summary-price">{d.price}</DialogDescription>
        </DialogHeader>
        <ul className="space-y-2" data-testid="checkout-summary-facts">
          {d.facts.map((f) => <li key={f} className="text-sm flex gap-2 text-neutral-300"><Check className="h-4 w-4 text-sky-300 shrink-0 mt-0.5" />{f}</li>)}
        </ul>
        <div className="space-y-1.5 text-xs text-neutral-500" data-testid="checkout-summary-terms">
          {d.terms.map((t) => <p key={t}>{t}</p>)}
          <p>Practice, documents, quizzes, Listen, Draw it and video keep their own daily limits. Have a discount code? Add it on the next page. Tax is added there if it applies where you live.</p>
        </div>
        <div className="flex flex-wrap gap-2 justify-end pt-1">
          <button onClick={onClose} className="h-10 px-5 rounded-full border border-white/15 text-sm hover:bg-white/5" data-testid="checkout-summary-cancel">Not now</button>
          <button onClick={onConfirm} disabled={!!busy} className="h-10 px-5 rounded-full bg-sky-400 text-white text-sm font-medium hover:bg-sky-500 disabled:opacity-50 inline-flex items-center gap-2" data-testid="checkout-summary-continue">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}{sub && !pick.endsWith("_day") ? "Review on Stripe" : "Continue to secure checkout"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
